import React from 'react';

type Props = {
  size?: number;
};

const DEFAULT_SIZE = 48;

const Spinner = (props: Props) => {
  const size = props.size ?? DEFAULT_SIZE;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: 'block',
      }}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      {...props}
    >
      <circle cx={75} cy={50} r={5}>
        <animate attributeName="r" values="3;3;5;3;3" dur="1s" repeatCount="indefinite" begin="-0.875s" />
        <animate
          attributeName="fill"
          values="#000000;#000000;#000000;#000000;#000000"
          repeatCount="indefinite"
          dur="1s"
          begin="-0.875s"
        />
      </circle>
      <circle cx={67.678} cy={67.678} r={5}>
        <animate attributeName="r" values="3;3;5;3;3" dur="1s" repeatCount="indefinite" begin="-0.75s" />
        <animate
          attributeName="fill"
          values="#000000;#000000;#000000;#000000;#000000"
          repeatCount="indefinite"
          dur="1s"
          begin="-0.75s"
        />
      </circle>
      <circle cx={50} cy={75} r={5}>
        <animate attributeName="r" values="3;3;5;3;3" dur="1s" repeatCount="indefinite" begin="-0.625s" />
        <animate
          attributeName="fill"
          values="#000000;#000000;#000000;#000000;#000000"
          repeatCount="indefinite"
          dur="1s"
          begin="-0.625s"
        />
      </circle>
      <circle cx={32.322} cy={67.678} r={5}>
        <animate attributeName="r" values="3;3;5;3;3" dur="1s" repeatCount="indefinite" begin="-0.5s" />
        <animate
          attributeName="fill"
          values="#000000;#000000;#000000;#000000;#000000"
          repeatCount="indefinite"
          dur="1s"
          begin="-0.5s"
        />
      </circle>
      <circle cx={25} cy={50} r={5}>
        <animate attributeName="r" values="3;3;5;3;3" dur="1s" repeatCount="indefinite" begin="-0.375s" />
        <animate
          attributeName="fill"
          values="#000000;#000000;#000000;#000000;#000000"
          repeatCount="indefinite"
          dur="1s"
          begin="-0.375s"
        />
      </circle>
      <circle cx={32.322} cy={32.322} r={5}>
        <animate attributeName="r" values="3;3;5;3;3" dur="1s" repeatCount="indefinite" begin="-0.25s" />
        <animate
          attributeName="fill"
          values="#000000;#000000;#000000;#000000;#000000"
          repeatCount="indefinite"
          dur="1s"
          begin="-0.25s"
        />
      </circle>
      <circle cx={50} cy={25} r={5}>
        <animate attributeName="r" values="3;3;5;3;3" dur="1s" repeatCount="indefinite" begin="-0.125s" />
        <animate
          attributeName="fill"
          values="#000000;#000000;#000000;#000000;#000000"
          repeatCount="indefinite"
          dur="1s"
          begin="-0.125s"
        />
      </circle>
      <circle cx={67.678} cy={32.322} r={5}>
        <animate attributeName="r" values="3;3;5;3;3" dur="1s" repeatCount="indefinite" begin="0s" />
        <animate
          attributeName="fill"
          values="#000000;#000000;#000000;#000000;#000000"
          repeatCount="indefinite"
          dur="1s"
          begin="0s"
        />
      </circle>
    </svg>
  );
};

export default Spinner;
